import { Grid } from '@mui/material';
import { HSpacer, RoutalPalette } from '@nx-smartmonkey/ui';
import { Text } from '../../../../react-components/Text';

interface RouteCompletedChipProps {
  icon?: React.ReactNode;
  intIdTitle?: string;
  value?: string;
  color?: string;
}

export const RouteCompletedChip = ({ icon, intIdTitle, value, color }: RouteCompletedChipProps) => {
  return (
    <Grid
      item
      container
      style={{
        display: `flex`,
        flexDirection: `row`,
        alignContent: `center`,
        justifyContent: `space-between`,
        alignItems: `center`,

        padding: `10px 0`,
      }}
    >
      <Grid
        item
        style={{
          display: `flex`,
          alignContent: `center`,
          alignItems: `center`,
          flexDirection: `row`,
          flexWrap: `nowrap`,
        }}
      >
        {icon}
        <HSpacer small />
        <Text intlId={intIdTitle} style={{ color: color ?? RoutalPalette.primary40 }} />
      </Grid>

      <Text>{value}</Text>
    </Grid>
  );
};
